import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ComingSoon.css';

export default function ComingSoon() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  return (
    <div className="coming-soon">
      <div className="coming-soon-content">
        <h1 className="coming-soon-brand">Prancing Peony Spa</h1>
        <h2 className="coming-soon-headline">Coming Soon</h2>
      </div>
      <Link to="/login" className="discreet-admin-link">Admin</Link>
    </div>
  );
}
